import React, { useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Container from '@mui/material/Container';
import { goToExport, goToExportEmergencyEWallet } from '../../components/ClientEntry/utils';
import './ExportOptions.scss';
import { tracking } from '../../utils/tracking';
import FunctionCardsContainer from '../../components/FunctionCard/FunctionCardsContainer';
import AddToEWalletDialog from './AddToEWalletDialog/AddToEWalletDialog';
import TravelKitLinkConstructor from './TravelKitLinkConstructor/TravelKitLinkConstructor';
import { HotLabel } from '../AdviserHomePage/HotLabel/HotLabel';
import CornerTriangle from '../../components/CornerTriangle/CornerTriangle';
import { toggleControl } from '../../store/control/duck';
import { clientPath } from '../../utils/client-route';

const ExportOptions = props => {
  const { intl, history, userDetails, toggleControl } = props;

  const [addToEWalletDialogOpen, setAddToEWalletDialogOpen] = useState(false);
  const [sosLinkDialogOpen, setSosLinkDialogOpen] = useState(false);

  // const shouldShowWalletPassButtons = hasCampaignCode(userDetails, teamCampaignCodes, 'FEATURE_EMINFO');  //limit by campaigncode
  const shouldShowWalletPassButtons = true; //avalible to all
  const shouldShowOnlineSosPaper = true; // available to all; was gated on FEATURE_SOS during testing

  const exportReview = () => {
    // Tracking
    tracking('Policy Review Accessed');
    toggleControl('chatGPTPersonalMessageDrawer', false);
    history.push('/policy_review');
  };
  const exportEmergency = () => {
    // Tracking
    tracking('Export Emergency Accessed');
    toggleControl('chatGPTPersonalMessageDrawer', false);
    goToExport(JSON.parse(sessionStorage.getItem('client')), history);
  };
  const exportEmergencyEWallet = () => {
    setAddToEWalletDialogOpen(true);
  };
  const exportOnlineSosPaper = () => {
    tracking('TravelKit Link Constructor Accessed');
    setSosLinkDialogOpen(true);
  };

  const closeAddToEWalletDialog = () => setAddToEWalletDialogOpen(false);
  const closeSosLinkDialog = () => setSosLinkDialogOpen(false);
  const onAddToEWalletSuccess = options => {
    tracking('Export Emergency E-Wallet Accessed');
    goToExportEmergencyEWallet(JSON.parse(sessionStorage.getItem('client')), history, options);
  };

  const clientId = JSON.parse(window.localStorage.getItem('clientId'));

  if (!clientId) {
    history.push(clientPath());
  }

  const currentClient = JSON.parse(sessionStorage.getItem('client'));

  return (
    <Fragment>
      <AddToEWalletDialog
        open={addToEWalletDialogOpen}
        onClose={closeAddToEWalletDialog}
        onSuccess={onAddToEWalletSuccess}
      />
      {shouldShowOnlineSosPaper && (
        <TravelKitLinkConstructor
          open={sosLinkDialogOpen}
          onClose={closeSosLinkDialog}
          client={currentClient}
          adviser={userDetails}
        />
      )}

      <div className="export-options">
        <Container className="addPolicyPadding">
          <FunctionCardsContainer
            items={[
              // 救命紙 leads. ClientV2's drawer promotes it by name and opens this
              // page, so the card the adviser came for has to be the first one
              // they see. V1 reaches the same page and gets the same order.
              {
                text: intl.formatMessage({ id: 'Emergency Reference' }),
                subtitle: intl.formatMessage({ id: 'export-emer-info' }),
                imgSrc: 'img/icons/emergency_reference_active_color.svg',
                imgAlt: 'export-emergency',
                color: '#3999f8',
                onClick: exportEmergency
              },
              shouldShowOnlineSosPaper && {
                text: intl.formatMessage({
                  id: 'export-online-sos-title',
                  defaultMessage: '發送旅行小錦囊'
                }),
                subtitle: intl.formatMessage({
                  id: 'export-online-sos-subtitle',
                  defaultMessage: '按目的地發送旅行急救網頁連結給客戶'
                }),
                imgSrc: 'img/icons/travel_kit_pin_active_color.svg',
                imgAlt: 'export-online-sos',
                color: '#059669',
                onClick: exportOnlineSosPaper,
                extras: (
                  <HotLabel
                    text={intl.formatMessage({ id: 'hot' })}
                    style={{ zIndex: 1, left: 'unset', right: 0, borderRadius: '4px 0 0 4px' }}
                  />
                )
              },
              {
                text: intl.formatMessage({ id: 'export-sum-desc' }),
                subtitle: intl.formatMessage({ id: 'export-sum-info' }),
                imgSrc: 'img/icons/policy_review_active_color.svg',
                imgAlt: 'export-review',
                color: '#5fc3d2',
                onClick: exportReview
              },
              shouldShowWalletPassButtons && {
                text: intl.formatMessage({ id: 'export-emer-e-wallet-desc' }),
                subtitle: intl.formatMessage({ id: 'export-emer-e-wallet-info' }),
                imgSrc: 'img/icons/e_wallet_active_color.svg',
                imgAlt: 'export-emergency-e-wallet',
                color: '#2260a5',
                onClick: exportEmergencyEWallet,
                extras: (
                  <Fragment>
                    <CornerTriangle
                      text="COT"
                      backgroundColor="#ffc000"
                      containerStyle={{ left: 6, borderRadius: 0 }}
                    />
                    <HotLabel
                      text={intl.formatMessage({ id: 'hot' })}
                      style={{ zIndex: 1, left: 'unset', right: 0, borderRadius: '4px 0 0 4px' }}
                    />
                  </Fragment>
                )
              }
            ]}
          />
        </Container>
      </div>
    </Fragment>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    connectedAdvisers: state.user.connectedAdvisers,
    teamCampaignCodes: state.functions.campaignCodes
  }),
  {
    toggleControl
  }
)(ExportOptions);

export default injectIntl(container);
